import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { api, ApiError } from "@/shared/api";
import { Logo } from "@/shared/components/Logo";
import { s } from "@/shared/strings";

// Consome o magic link (?t=) e entra no /host.
export function MagicConsume() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const t = params.get("t");

  useEffect(() => {
    if (!t) {
      return;
    }
    api
      .magicConsume(t)
      .then(() => nav("/host", { replace: true }))
      .catch((e) => setErr(e instanceof ApiError ? e.message : "Erro inesperado."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const message = err || (!t ? "Link inválido." : "");

  return (
    <main className="bg-bg flex min-h-dvh flex-col items-center justify-center gap-6 px-6">
      <Logo />
      {message ? (
        <>
          <p className="text-18 text-bad font-semibold">{message}</p>
          <Link to="/entrar" className="text-amber-fg hover:underline">
            {s.login}
          </Link>
        </>
      ) : (
        <p className="animate-pulse-soft text-18 text-chalk-2">Entrando…</p>
      )}
    </main>
  );
}
